module.exports = __webpack_public_path__ + "static/media/EDU-Dashboard.1e35841b.png";